import { render, staticRenderFns } from "./sidebar-kefu.vue?vue&type=template&id=4a5283e0&scoped=true&"
import script from "./sidebar-kefu.vue?vue&type=script&lang=js&"
export * from "./sidebar-kefu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-kefu.vue?vue&type=style&index=0&id=4a5283e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5283e0",
  null
  
)

export default component.exports